/**
 * HomeARDemoHelpContentView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait HomeARDemoHelpContent
 */

import { useHomeARDemoHelpContentLogic } from '@/hooks/traits/useHomeARDemoHelpContentLogic';
import type { HomeARDemoHelpContentConfig } from '@/hooks/traits/useHomeARDemoHelpContentLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { HomeARDemoHelpTicket } from '@app/shared';
import { HomeARDemoTicketQueueView } from '@/components/traits/HomeARDemoTicketQueueView';
import { HomeARDemoHelpStatsView } from '@/components/traits/HomeARDemoHelpStatsView';
import { Stack } from '@almadar/ui/components';
import { Typography } from '@almadar/ui/components';
import { UISlotComponent, renderPatternValue } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';
import { useTranslate } from '@almadar/ui/hooks';

interface HomeARDemoHelpContentViewProps {
  config?: Partial<HomeARDemoHelpContentConfig>;
}

export function HomeARDemoHelpContentView({ config: propsConfig }: HomeARDemoHelpContentViewProps) {
  const { t: __t, locale: __locale } = useTranslate();
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useHomeARDemoHelpContentLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['HomeARDemoHelpTicket'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="HomeAR" trait="HomeARDemoHelpContent">
      {slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" className="p-4" gap="sm"><Stack direction="horizontal" align="baseline" gap="sm"><Typography variant="h3" content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.title"))} /><Typography content={renderPatternValue(__t("std-almadar-demo-helpdesk-page:page.subtitle"))} color="muted" variant="small" /></Stack><HomeARDemoHelpStatsView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><HomeARDemoTicketQueueView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}
    </TraitScopeProvider>
  );
}

export default HomeARDemoHelpContentView;
